import { Dialog, DialogProps, useMediaQuery, useTheme } from "@mui/material";

const ResponsiveDialog = (props: DialogProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const PaperPropsSx: any = {
    ...(props.PaperProps?.sx || {}),
    // make table pinned columns white in dialogs to match dialog background color - bypass color used on regular page tables
    "& .MuiDataGrid-columnHeader--pinnedLeft, & .MuiDataGrid-columnHeader--pinnedRight, & .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight": {
      backgroundColor: "inherit !important",
    },
  };

  const DialogSx: any = {
    ...(props.sx || {}),
  };

  // if fullScreen - bypass any styling added to the Paper or Dialog at the parent component level and make sure we take up the full screen
  if (fullScreen) {
    PaperPropsSx.maxHeight = "100vh";

    DialogSx.width = "100vw";
    DialogSx.height = "100vh";
    DialogSx.marginLeft = "0px";
    DialogSx.marginTop = "0px";
    DialogSx.zIndex = 1200;
  }

  return (
    <Dialog
      {...props}
      fullScreen={props.hasOwnProperty("fullScreen") ? props.fullScreen : fullScreen}
      fullWidth
      maxWidth={props.maxWidth ?? "xl"}
      sx={DialogSx}
      PaperProps={{
        ...props.PaperProps,
        sx: PaperPropsSx,
      }}
      disableEnforceFocus
    >
      {props.children}
    </Dialog>
  );
};

export default ResponsiveDialog;
